import { withBemMod } from '@bem-react/core';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelAboutCompany } from 'client/common/types';

import { cnLevel, ILevelProps } from '..';

import './level_type_aboutCompany.css';

export interface ILevelTypeAboutCompanyProps extends Omit<ILevelAboutCompany, 'type'> {
    type?: 'aboutCompany';
}

export const withLevelTypeAboutCompany = withBemMod<ILevelTypeAboutCompanyProps, ILevelProps>(
    cnLevel(),
    { type: 'aboutCompany' },
    (BaseLevel: React.FC<ILevelProps>) => props => {

        const { blocks, ...otherProps } = props;

        return (
            <BaseLevel {...otherProps}>
                <>
                    {blocks.map(({ title, text }) => (
                        <div key={title} className={cnLevel('info')}>
                            <HtmlContent className={cnLevel('info-section')} content={title} />
                            <HtmlContent className={cnLevel('text')} content={text} />
                        </div>
                    ))}
                </>
            </BaseLevel>
        );
    }
);
